import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import PropTypes from 'prop-types';

const Animation = props => (
	<ScrollAnimation animateIn={props.animateIn} animateOnce offset={1} {...props}>
		{props.children}
	</ScrollAnimation>
);

export default Animation;

Animation.defaultProps = {
	animateIn: 'fadeIn'
};

Animation.propTypes = {
	animateIn: PropTypes.string.isRequired
};
